<script>
  import MusicPlayer from "./MusicPlayer.svelte";

  export let questions;
  export let step;
  export let goToNextStep;
  let src = "/assets/logo-11.jpg";

  $: activeQuestion = questions[step - 1];

  function chooseOption1() {
    goToNextStep(activeQuestion.property1);
  }
  function chooseOption2() {
    goToNextStep(activeQuestion.property2);
  }
</script>

<main>
  <p>Which image suits you best?</p>
  <p>Step {step}</p>
  <div class="flex">
    {#if activeQuestion.type === "image"}
      <div>
        <img src={activeQuestion.image1} alt="" />
        <p on:click={chooseOption1}><button>I choose this one</button></p>
      </div>
      <div>
        <img src={activeQuestion.image2} alt="" />
        <p on:click={chooseOption2}><button>I choose this one</button></p>
      </div>
    {/if}

    {#if activeQuestion.type === "music"}
      <div>
        <MusicPlayer
          imageUrl={activeQuestion.image1}
          musicUrl={activeQuestion.music1}
        />
        <p on:click={chooseOption1}><button> I choose this one</button></p>
      </div>
      <div>
        <MusicPlayer
          imageUrl={activeQuestion.image2}
          musicUrl={activeQuestion.music2}
        />
        <p on:click={chooseOption2}><button>I choose this one</button></p>
      </div>
    {/if}
  </div>
</main>

<style>
  main {
    /* background: rgba(255, 255, 255, 0.822); */
    /*background: rgba(255, 255, 255, 0.822) url(/assets/achtergrond2.png);*/
    background: #f0f0f0;
    color: rgba(0, 0, 0, 0.822);
    width: 100%;
    min-height: 100vh;
    flex-direction: column;
  }
  p {
    color: #020202;
    font-size: 2, 5em;
    font-weight: 100;
  }
  .flex {
    flex-direction: row;
    display: flex;
    justify-content: center;
    gap: 50px;
  }

  img {
    width: 200px;
    height: 200px;
  }
</style>
